/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import { useMemo } from 'react';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { usePageContentId } from '@confluence/page-context';
import { useContentStatus } from '@confluence/page-utils/entry-points/useContentStatus';

import { normalizeContentCreatedData } from '../normalizers/normalizeContentCreatedData';

import type {
	useContentCreatedDateDetailsPanelContentCreatedDateQuery as useContentCreatedDateDetailsPanelContentCreatedDateQuery$data,
	useContentCreatedDateDetailsPanelContentCreatedDateQueryVariables as useContentCreatedDateDetailsPanelContentCreatedDateQuery$variables,
} from './__types__/useContentCreatedDateDetailsPanelContentCreatedDateQuery';

const useContentCreatedDateDetailsPanelContentCreatedDateQuery = graphql`
	query useContentCreatedDateDetailsPanelContentCreatedDateQuery(
		$contentId: ID!
		$status: String!
	) {
		content(id: $contentId, status: [$status]) {
			nodes {
				id
				metadata {
					createdDate
				}
			}
		}
	}
`;
export const useContentCreatedDate = () => {
	const [contentId] = usePageContentId();

	const {
		contentStatus,
		loading: isContentStatusLoading,
		error: contentStatusError,
		refetch: refetchContentStatus,
	} = useContentStatus();

	const { data, loading, error, refetch } = useQuery<
		useContentCreatedDateDetailsPanelContentCreatedDateQuery$data,
		useContentCreatedDateDetailsPanelContentCreatedDateQuery$variables
	>(useContentCreatedDateDetailsPanelContentCreatedDateQuery, {
		variables: {
			contentId: contentId ?? '',
			status: contentStatus ?? '',
		},
		skip: isContentStatusLoading || !!contentStatusError || !contentStatus || !contentId,
	});
	const normalizedData = useMemo(() => normalizeContentCreatedData(data), [data]);

	return {
		data: normalizedData,
		loading,
		error: contentStatusError || error,
		refetch: !!contentStatusError ? refetchContentStatus : refetch,
	};
};
